// ייצוא PNG של גרף (ADAPT מ-v1 answer/web/png.js): רינדור קבוע-רוחב של ה-SVG (לא צילום מסך),
// משתני CSS נפתרים לפני סריאליזציה, ו"נכון ל-" נצרב לתוך התמונה — מספר בלי זמן נראה נכון לנצח.
const WIDTH = 1000;
const FONT = '"Figtree", "Noto Sans Hebrew", "Segoe UI", Arial, sans-serif';
const VAR_RE = /var\((--[a-z0-9-]+)\)/gi;

function resolveVars(markup: string): string {
  const cs = getComputedStyle(document.documentElement);
  return markup.replace(VAR_RE, (m, name: string) => cs.getPropertyValue(name).trim() || m);
}

const token = (name: string, fallback: string) => {
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v ? `hsl(${v})` : fallback;
};

export async function svgToPng(svg: SVGSVGElement, meta: { title?: string; stamp: string }): Promise<Blob> {
  const clone = svg.cloneNode(true) as SVGSVGElement;
  const w = Number(svg.getAttribute('width')) || svg.clientWidth || 720;
  const h = Number(svg.getAttribute('height')) || svg.clientHeight || 300;
  const scale = WIDTH / w;
  const chartH = Math.round(h * scale);
  clone.setAttribute('viewBox', `0 0 ${w} ${h}`);
  clone.setAttribute('width', String(WIDTH));
  clone.setAttribute('height', String(chartH));
  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  clone.setAttribute('style', `font-family:${FONT}`);
  const markup = resolveVars(new XMLSerializer().serializeToString(clone));

  const padT = meta.title ? 44 : 16;
  const padB = 34;
  const H = padT + chartH + padB;
  const DPR = 2; // קבוע — לא devicePixelRatio: אותה תמונה מכל מכשיר
  const canvas = document.createElement('canvas');
  canvas.width = WIDTH * DPR;
  canvas.height = H * DPR;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('canvas-unavailable');
  ctx.scale(DPR, DPR);
  ctx.fillStyle = token('--background', '#ffffff');
  ctx.fillRect(0, 0, WIDTH, H);

  const url = URL.createObjectURL(new Blob([markup], { type: 'image/svg+xml;charset=utf-8' }));
  try {
    const img = new Image();
    await new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = () => reject(new Error('svg-load-failed'));
      img.src = url;
    });
    ctx.drawImage(img, 0, padT, WIDTH, chartH);
  } finally {
    URL.revokeObjectURL(url);
  }
  const fg = token('--foreground', '#111111');
  ctx.direction = 'rtl';
  ctx.textAlign = 'right';
  if (meta.title) {
    ctx.fillStyle = fg;
    ctx.font = `600 19px ${FONT}`;
    ctx.fillText(meta.title, WIDTH - 18, 30);
  }
  ctx.font = `12.5px ${FONT}`;
  ctx.fillStyle = fg;
  ctx.globalAlpha = 0.72;
  ctx.fillText(meta.stamp, WIDTH - 18, padT + chartH + 22);
  ctx.globalAlpha = 1;
  return new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('toBlob-failed'))), 'image/png'));
}

export function downloadBlob(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
